<template>
  <div class="d-flex flex-column justify-center fill-height">
    <span class="d-block text--secondary mb-3" v-if="!hideTitle">
      {{ $t("message.common.changeSinceLastWeek") }}
    </span>
    <div class="last-month mb-1" :class="checkIsIncreasing(lastAudit).color">
      <span
        class="zmdi last-month__icon mr-4"
        :class="checkIsIncreasing(lastAudit).icon"
      ></span>
      <span>{{ lastAuditValue }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpansionPanelHeaderLastAudit",
  props: {
    hideTitle: {
      type: Boolean,
      default: false
    },
    showZero: {
      type: Boolean,
      default: false
    },
    lastAudit: {
      validator: prop =>
        typeof prop === "number" || prop === null || typeof prop === "string",
      required: true
    }
  },
  computed: {
    lastAuditValue() {
      const lastAudit = parseInt(this.lastAudit);
      if (lastAudit !== 0) {
        return `${Math.abs(lastAudit)}%`;
      }
      return this.showZero ? "0%" : this.$t("message.common.noChanges");
    }
  },
  methods: {
    checkIsIncreasing(val) {
      if (!val || val === "0") {
        return { icon: "zmdi-circle", color: "last-month--default" };
      }
      if (val.toString().charAt(0) === "-") {
        return {
          icon: "zmdi-arrow-left last-month__icon last-month__icon--down",
          color: "last-month--danger"
        };
      }
      return {
        icon: "zmdi-arrow-left last-month__icon last-month__icon--up",
        color: "last-month--success"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.last-month {
  display: flex;
  align-items: center;

  &--success {
    color: $success;
  }

  &--danger {
    color: $danger;
  }

  &--default {
    color: $gray-light;
  }
}

.last-month__icon {
  margin-top: 2px;
  font-size: 20px;
  margin-right: 4px !important;

  &--up {
    transform: rotate(90deg);
  }

  &--down {
    transform: rotate(-90deg);
  }
}
</style>
